
import CTA from "../components/CTA";
import Feature from "../components/Feature";
import Hero from "../components/Hero";
import "../styles/home.css";


export default function Home() {
  return (
    <div className="home">
      <Hero />
      <Feature />
      <CTA />
    </div>
  );
}
